<ng-container
    *ngTemplateOutlet="isAuthRoute() ? authRoute : defaultLayout"
></ng-container>

<ng-template #authRoute>
    <app-auth></app-auth>
</ng-template>

<ng-template #defaultLayout>
    <div class="container">
        <div class="header">
            <app-header-v2 [layout]="'school'" [navigationButtons]="navigationButtons()"></app-header-v2>
        </div>
        <div class="main">
            <div class="ai-assistant-wrapper">
                <app-ai-assistant-v2 [sheetProgress]="progress()"></app-ai-assistant-v2>
            </div>

            <app-bottom-sheet [capNavItems]="capNavItems()" (progressChange)="onSheetProgress($event)">
                <router-outlet></router-outlet>
            </app-bottom-sheet>
        </div>
    </div>
</ng-template>
